import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { useLocaleKeys } from '~/i18n';
export const GetPingStepsTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            PingStepsTID: {
                HelpCenterLink: 'ping-help-center-link'
            }
        }
    });
export const PingSteps = ()=>{
    const { t: pingTexts } = useLocaleKeys('integrations.ping');
    const { PingStepsTID } = useMemo(()=>GetPingStepsTID(), []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: pingTexts.stepOpenIntegrations()
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: pingTexts.stepPasteApiKey()
            }),
            /*#__PURE__*/ _jsx(ExternalLinkButton, {
                href: "https://help.sayanchor.com/en/articles/15293356-ping",
                openInNewTab: true,
                style: {
                    marginTop: 16
                },
                testId: PingStepsTID.HelpCenterLink(),
                bi: {
                    name: 'ping_help_center_link'
                },
                children: pingTexts.readMoreInHelpCenter()
            })
        ]
    });
};
